@let anvandareVikarier = anvandareVikarier$ | async;

<rask-page
    pageTitle="Vikariehantering"
    noPadding>
    <rask-container-block>
        <rask-button (click)="createClickSrc.next()">Lägg till</rask-button>
        <rask-list [data]="anvandareVikarier" [virtualScroll]="true" virtualScrollType="window"
            [virtualScrollItemHeight]="36" [fixedHeader]="true" key="id">
            <rask-list-column
                header="Namn"
                [sortable]="true"
                width="80px">
                <ng-template let-row="row">
                    <a routerLink="./" [queryParams]="{id: row.id}">{{row.anvandare.namn}}
                        ({{row.anvandare.userName}})</a>
                </ng-template>
            </rask-list-column>
            <rask-list-column
                header="Vikarie"
                field="vikarie.namn"
                [sortable]="true"
                width="80px">
                <ng-template let-row="row">
                    {{row.vikarie.namn}} ({{row.vikarie.userName}})
                </ng-template>
            </rask-list-column>
            <rask-list-column
                header="Från datum"
                field="franDatum"
                [sortable]="true"
                width="80px">
                <ng-template let-row="row">
                    {{row.franDatum | date:'yyyy-MM-dd'}}
                </ng-template>
            </rask-list-column>
            <rask-list-column
                header="Till datum"
                field="tillDatum"
                [sortable]="true"
                width="80px">
                <ng-template let-row="row">
                    {{row.tillDatum | date:'yyyy-MM-dd'}}
                </ng-template>
            </rask-list-column>
            <rask-list-column width="90px">
                <ng-template let-row="row">
                    <rask-icon-button negative (click)="removeClickSrc.next(row)"
                        icon="far fa-trash-alt fa-lg"></rask-icon-button>
                </ng-template>
            </rask-list-column>
        </rask-list>
    </rask-container-block>
</rask-page>